import { getCategoryName } from "@/assets/data/blog-categories";
import Link from "next/link";

export const BlogCard = ({ blogData }) => {

    let redirectUrl = `/${blogData?.category}/${blogData?.slug}`

    return (
        <Link href={redirectUrl} className="w-full min-h-[480px] border rounded-lg hover:border-[#EB532E] transition-all duration-500 flex flex-col justify-between group shadow-lg max-w-md lg:max-w-none mx-auto bg-white">
            <div>
                <img
                    src={encodeURI(blogData?.thumbNail)}
                    alt={blogData?.altImgName || blogData?.title}
                    fetchPriority="high"
                    className='object-cover w-full rounded-t-lg h-[192px]'
                />

                <div className="flex flex-col items-start justify-center w-full text-left p-6">
                    <div className="w-full flex items-center mb-2 gap-[10px] ">
                        <div className="text-sm font-bold border border-[#D1D5DB] text-[#EB532E] px-3 py-1 rounded-full">{getCategoryName(blogData?.category)}</div>
                        <p className="text-gray-400 uppercase text-[12px]">{blogData?.readingTime} Mins</p>
                    </div>
                    <div className="flex justify-between items-start gap-8">
                        <div className="font-semibold break-words text-lg md:text-xl w-full group-hover:underline transition-all duration-500">{blogData?.title}</div>
                        <div className="rotate-45 xs:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="group-hover:text-[#EB532E] transition-all duration-500" width="30" height="30" viewBox="0 0 24 24">
                                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m5 12l7-7l7 7m-7 7V5" />
                            </svg>
                        </div>
                    </div>

                    <p className="line-clamp-5 whitespace-pre-line mt-4">
                        {blogData?.description}
                    </p>
                </div>
            </div>
            <div className="flex items-center gap-2 group-hover:visible invisible p-3 justify-end w-full">
                <p className="uppercase text-[12px] text-[#EB532E]">Continue Reading</p>
                <div className="rotate-90">
                    <svg xmlns="http://www.w3.org/2000/svg" className="text-[#EB532E]" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m5 12l7-7l7 7m-7 7V5" />
                    </svg>
                </div>
            </div>
        </Link>
    )
}